/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OutputFormat {
    CSV = 'csv',
    JSON = 'json',
    XLSX = 'xlsx',
}
